import React, {FC, PropsWithChildren} from "react";

export const Authenticated: FC<PropsWithChildren> = ({children}) => {
    return <>{children}</>;
}